import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '@/components/base/PageHeader';

const services = [
  {
    icon: 'ri-paint-brush-line',
    title: 'Siebdruck',
    description: 'Hochwertiger Siebdruck auf verschiedensten Materialien für langlebige und farbintensive Ergebnisse. Ideal für Textilien, Werbeartikel und Schilder.',
  },
  {
    icon: 'ri-profile-line',
    title: 'Geschäftsausstattung',
    description: 'Professionelle Visitenkarten, Briefpapier, Kuverts und Geschäftsdrucksachen, die Ihr Unternehmen repräsentieren und einen bleibenden Eindruck hinterlassen.',
  },
  {
    icon: 'ri-pages-line',
    title: 'Flyer & Broschüren',
    description: 'Ansprechende Flyer und Broschüren für Ihre Werbung — von der Gestaltung bis zum fertigen Druck. In verschiedenen Formaten, Auflagen und Papierqualitäten.',
  },
  {
    icon: 'ri-image-line',
    title: 'Plakate & Werbemittel',
    description: 'Großformatige Plakate und wirkungsvolle Werbemittel für maximale Aufmerksamkeit bei Ihrer Zielgruppe. Für Indoor und Outdoor geeignet.',
  },
  {
    icon: 'ri-sticky-note-line',
    title: 'Aufkleber & Etiketten',
    description: 'Individuelle Aufkleber und Etiketten in verschiedenen Formen, Größen und Materialqualitäten — wetterfest, reißfest oder transparent nach Wunsch.',
  },
  {
    icon: 'ri-award-line',
    title: 'Sonderanfertigungen',
    description: 'Maßgeschneiderte Drucklösungen für besondere Anforderungen — wir realisieren auch ausgefallene Projekte, die andere nicht annehmen.',
  },
  {
    icon: 'ri-lightbulb-line',
    title: 'Beratung & Druckvorstufe',
    description: 'Kompetente Beratung zu Materialien, Formaten und Veredelungen sowie professionelle Druckdatenaufbereitung für optimale Druckergebnisse.',
  },
  {
    icon: 'ri-palette-line',
    title: 'Design & Gestaltung',
    description: 'Kreative Gestaltung Ihrer Druckvorlagen durch unser erfahrenes Team — von der ersten Idee zum fertigen Layout, ganz nach Ihren Vorstellungen.',
  },
];

export default function Leistungen() {
  useEffect(() => {
    document.title = 'Leistungen | Druckerei Rahmede';
  }, []);

  return (
    <>
      <PageHeader
        label="Unsere Leistungen"
        title="Alles aus einer Hand"
        subtitle="Von der Beratung über die Gestaltung bis zum fertigen Druck — wir bieten das komplette Leistungsspektrum für Ihre Druckprojekte."
      />

      <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {services.map((service) => (
              <div
                key={service.title}
                className="bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/50"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100/70 mb-4">
                  <i className={`${service.icon} text-lg text-accent-600`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                  {service.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {service.description}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-12 md:mt-16 bg-primary-600 rounded-lg p-8 md:p-12 text-center">
            <h3 className="font-heading text-xl md:text-2xl font-bold text-white mb-3">
              Haben Sie ein besonderes Projekt?
            </h3>
            <p className="text-white/80 text-sm md:text-base max-w-lg mx-auto mb-6">
              Wir beraten Sie gerne persönlich und erstellen ein maßgeschneidertes Angebot für Ihre individuellen Anforderungen.
            </p>
            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white text-primary-600 text-sm font-semibold rounded-md hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Angebot anfordern
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}